import { useState, useEffect } from "react";

import { serviceBackdropGet, serviceBackdropSet } from "services/graphql/call";

export const useMainBackdrop = (options = {}) => {
  const [backdropSelect, setBackdropSelect] = useState(
    options.backdropSelect || null,
  );
  const [backdropActive, setBackdropActive] = useState(null);

  const setBackdrop = (value) => {
    const backdrop = serviceBackdropSet(value);
    setBackdropSelect(backdrop);
  };

  useEffect(() => {
    function setBackdropBodyClass(className) {
      if (className.includes("dripflag")) {
        let flagCode = className.split("-")[1];
        document.body.className = "backdrop dripflag";
        document.body.style.backgroundImage = `url(/images/flags/${flagCode}.png)`;
      } else {
        document.body.style.backgroundImage = "";
        document.body.className = className;
      }
    }

    let user = options.user || { connected: false };
    let backdrop;

    if (user.connected) {
      // set static backdrop based on user setting
      if (backdropSelect) {
        backdrop = backdropSelect;
      } else {
        backdrop = serviceBackdropGet();
      }
      setBackdropBodyClass(backdrop);
      setBackdropActive(backdrop);
    } else {
      // set a rotating backdrop of flags for non-connected users that fades in and out every 5 seconds
      let index = 0;
      const flags = [
        // west europe
        "gb",
        "ch",
        "fr",
        "de",
        "it",
        "es",
        "nl",
        "se",
        "no",
        "fi",
        "dk",
        "be",
        "at",
        "ie",
        "pt",
        "gr",
        // north america
        "us",
        "ca",
        "mx",
        // rollout
        // // east europe
        // "ru",
        // "pl",
        // "cz",
        // "hu",
        // "ro",
        // "bg",
        // // south america
        // "br",
        // "ar",
        // "co",
        // "ve",
        // // asia
        // "cn",
        // "jp",
        // "kr",
        // "in",
        // "sg",
        // "hk",
        // // africa
        // "za",
        // "ng",
        // "eg",
        // "ke",
        // "ma",
      ];

      // preload flag images
      flags.forEach((flag) => {
        const img = new Image();
        img.src = `/images/flags/${flag}.png`;
      });

      document.body.className = "backdrop dripflag";
      document.body.style.backgroundImage = `url(/images/flags/${flags[0]}.png)`;
      const interval = setInterval(() => {
        let randomFlag = flags[Math.floor(Math.random() * flags.length)];
        document.body.style.backgroundImage = `url(/images/flags/${randomFlag}.png)`;
        index = (index + 1) % flags.length;
      }, 5000);

      if (backdropSelect) {
        backdrop = backdropSelect;
        setBackdropBodyClass(backdrop);
        setBackdropActive(backdrop);
        clearInterval(interval);
      }

      return () => {
        clearInterval(interval);
      };
    }

    return () => {
      document.body.className = "";
    };
  }, [options.user, backdropSelect]);

  return [backdropActive, setBackdrop];
};

// USAGE
// useMainBackdrop(props);
// const [backdropActive, setBackdrop] = useMainBackdrop(props);
